module.exports = __webpack_public_path__ + "static/media/rival-rush.bc1c6bdf.png";